/* Directive */
var VueDirective = {
    "tooltip" : {
        bind: function (el, binding) {
            var text = typeof binding.value == "string" ? binding.value : binding.value.text;
            var options = {
                html: true,
                placement: 'auto',
                title: text,
                trigger: 'hover',
            }
            if(typeof binding.value == "object") options = Object.assign(options, binding.value)
            $(el).tooltip(options);
        },
        componentUpdated: function (el, binding) {
            $(el).tooltip('destroy')
            var text = typeof binding.value == "string" ? binding.value : binding.value.text;
            var options = {
                html: true,
                placement: 'auto',
                title: text,
                trigger: 'hover',
            }
            if(typeof binding.value == "object") options = Object.assign(options, binding.value)
            $(el).tooltip(options)
        },
    }
}

export default VueDirective